import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        VForm,
        { ref: "form" },
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "12" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "", justify: "center" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.domain) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-8" },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              items: _vm.domainList,
                              rules: _vm.rules.organization,
                            },
                            model: {
                              value: _vm.pickDomain,
                              callback: function ($$v) {
                                _vm.pickDomain =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "pickDomain",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "12" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "", justify: "center" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.project) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-8" },
                        [
                          _c(VSelect, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              items: _vm.projectListDict[_vm.pickDomain],
                              rules: _vm.rules.project,
                            },
                            model: {
                              value: _vm.record.project_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.record,
                                  "project_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "record.project_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "12" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "", justify: "center" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v("Dataset :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-8" },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rules: _vm.rules.dataset,
                            },
                            model: {
                              value: _vm.record.dataset_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.record,
                                  "dataset_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "record.dataset_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "12" } },
                [
                  _c(
                    VRow,
                    { attrs: { dense: "", justify: "center" } },
                    [
                      _c(
                        VCol,
                        { staticClass: "col-md-2" },
                        [
                          _c(
                            VSubheader,
                            { staticClass: "font-weight-bold p-0" },
                            [_vm._v(_vm._s(_vm.texts.table) + " :")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { staticClass: "col-md-8" },
                        [
                          _c(VTextField, {
                            attrs: {
                              outlined: "",
                              dense: "",
                              rules: _vm.rules.table,
                            },
                            model: {
                              value: _vm.record.table_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.record,
                                  "table_name",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "record.table_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }